document.addEventListener('DOMContentLoaded', () => {
  const BUTTON_ID = 'f-button-1755269768hn8Wx';      // <a id="...">
  const EMBED_TAG = 'shopify-forms-embed';           // host del app

  const btn = document.getElementById(BUTTON_ID);
  if (!btn) return;

  // Pequeña utilidad para esperar nodos
  const waitFor = (getEl, { tries = 40, interval = 100 } = {}) =>
    new Promise((resolve, reject) => {
      let n = 0;
      const t = setInterval(() => {
        const el = getEl();
        if (el) { clearInterval(t); resolve(el); }
        else if (++n >= tries) { clearInterval(t); reject(new Error('No encontrado')); }
      }, interval);
    });

  async function openFormsModal() {
    // Espera a que exista el custom element
    await (customElements.get(EMBED_TAG) || customElements.whenDefined(EMBED_TAG));

    const host = document.querySelector(EMBED_TAG);
    if (!host) throw new Error('<shopify-forms-embed> no está en la página');

    // Acceso al shadow root
    const root = host.shadowRoot;
    if (!root) throw new Error('No se pudo acceder al shadowRoot');

    // Asegura que el árbol interno esté renderizado
    await waitFor(() => root.getElementById('app-embed')).catch(()=>{});

    // 1) Si hay un “launcher” interno, haz click
    const launcher =
      root.querySelector('[data-testid*="open" i], [data-testid*="launcher" i]') ||
      root.querySelector('button, [role="button"]');
    if (launcher) launcher.click();

    // 2) Si ya existe el diálogo pero oculto, muéstralo
    const dialog = root.querySelector('section[role="dialog"][aria-modal="true"]');
    if (dialog) {
      dialog.removeAttribute('hidden');
      dialog.style.display = 'block';
      const overlay = root.querySelector('[class*="overlay"]');
      if (overlay) { overlay.style.display = 'block'; overlay.removeAttribute('hidden'); }
    }

    // 3) Enfoca el primer input para UX
    setTimeout(() => {
      const first = root.querySelector('input, select, textarea, button');
      if (first) first.focus({ preventScroll: false });
    }, 60);
  }

  // Intercepta el “Open pop-up” del tema y usa el modal de Forms
  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();   // bloquea el pop-up del tema
    openFormsModal().catch(err => console.error('[Forms]', err));
  };

  // El <a> actuará como botón accesible
  btn.addEventListener('click', handle);
  btn.setAttribute('role', 'button');
  btn.setAttribute('tabindex', '0');
  btn.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handle(e); }
  });
});